import styled from 'styled-components';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const actions = styled.div`
    ${dFlexColumn};
    flex: none;
    gap: var(--space-sm);
    padding: var(--space-lg);
    margin-top: auto;
`;
